// Load polyfills
import 'vue-svgicon/dist/polyfill'

// Bootstrap VUE
import Vue from 'vue'
import {sync} from 'vuex-router-sync'
import router from '@/router'
import store from '@/store'
import App from '@/App'

// Plugins
import VueI18n from 'vue-i18n'
import moment from 'vue-moment'
import VTooltip from 'v-tooltip'
import VueCurrencyFilter from 'vue-currency-filter'
import * as VueGoogleMaps from 'vue2-google-maps'

// Localization
import en from './locales/en.json'
import nl from './locales/nl.json'
import fr from './locales/fr.json'

// SYNC
sync(store, router);

// USE Plugins
Vue.use(VueI18n);
Vue.use(moment);
Vue.use(VTooltip);
Vue.use(VueCurrencyFilter, {
    symbol : '€',
    thousandsSeparator: window.app.config.locale === 'en' ? ',' : '.',
    fractionCount: 2,
    fractionSeparator: window.app.config.locale === 'en' ? '.' : ',',
    symbolPosition: 'front',
    symbolSpacing: true
});

Vue.use(VueGoogleMaps, {
    load: {
        key: window.app.config.mapsKey,
        libraries: 'places',
    }
})

// Create messages
const messages = {
    en: en,
    nl: nl,
    fr: fr
};

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: window.app.config.locale,
    messages
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#js-ra-mount',
    router,
    store,
    i18n,
    components: {App},
    template: '<App/>'
});

export {router, store}




// WEBPACK FOOTER //
// ./src/main.js